import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { customerCredit, CustomerCreditViewModel } from "./customerCredit-viewModel"

export class CustomerCreditView extends View<CustomerCreditViewModel>{
    GetViewUniqueId(): string {
        return "V-B60C5201-DD03-473A-BA30-4FC9A1A3635E"
    }
    loadHtml(): string {
        let element = require('./customerCredit.html').default;
        let style = require('./customerCredit.less');
        return element;
    }
    constructor() {
       super();
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set customerCredits(v: ObservableArray<customerCredit>) { this._customerCredits = v; } public get customerCredits(): ObservableArray<customerCredit> { return this._customerCredits;} private _customerCredits: ObservableArray<customerCredit>;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    async create() {
        this.dataContext.create();
    }
}
